// PreferredUsername未設定時のデフォルト値として利用する
export const defaultPreferredUsername = '未設定';
